import React, {useState, createRef, useEffect, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {getCookie} from '../../../../utils/getCookie';
import {bankNames, paymentModeData, selectTimeData, bankName} from './mock';
import dateformat from 'dateformat';
import useOutsideClick from '@ibibo/use-outside-click';
import SelectBox from '../../common/SelectBox/SelectBox';
import TextInput from '../../common/TextInput/TextInput';
import Uploader from '../../common/Uploader/Uploader';
import CalendarBlock from '../../Wallet/RightBlock/WalletStatement/WalletCalendar';
import {postRefundRaiseRequest} from '@ibibo/myaccount-reducer';

import * as S from './RaiseWalletRequest.styles';
import CalenderIcon from 'icon-selector/src/icons/mytrips/calender';
//import FaqStories from 'verticals/hotels-dweb/src/stories/components/hotels/DetailsPage/Faq/Faq.stories';

const RaiseWalletRequest = ({closeModal, setModalFlag, sendTrackingDataToSdk}) => {
  const dispatch = useDispatch();
  const ccdeCookie = getCookie('ccde');
  const startDateRef = createRef();
  const listRef = createRef();
  const [calendarMode, setCalendarMode] = useState('start');
  const [showDate, setShowDate] = useState(false);
  const [fieldIsFocus, setFieldIsFocus] = useState(false);
  const [time, setTime] = useState(null);
  const [utr, setUtr] = useState(ccdeCookie === 'AE' ? '' : null);
  const [isDisabled, setIsDisabled] = useState(true);
  const [inputValue, setInputValue] = useState('');
  const [utrId, setUtrId] = useState('');
  const [transactionAmount, setTransactionAmount] = useState('');
  const [files, setFiles] = useState([]);
  const [failureMessage, setFailureMessage] = useState('');
  const [calenderHandle, setCalenderHandle] = useState(false);

  const [walletStatementDates, setDates] = useState({
    startDate: new Date(),
  });
  const [formFields, setFormFields] = useState({
    paymentMode: '',
    transactionTime: '',
    transactionDate: new Date(),
    transactionAmount: '',
    bankName: '',
    paymentScreenshot: '',
    utr: '',
  });

  const [formFieldsError, setFormFieldsError] = useState({
    paymentMode: '',
    transactionDateTime: '',
    transactionAmount: '',
    bankName: '',
  });

  const [postObject, setPostObject] = useState({
    utr: '',
    paymentMode: '',
    transactionDateTime: '',
    transactionAmount: '',
    bankName: '',
    paymentScreenshot: '',
  });

  useEffect(() => {
    setFormFields({
      ...formFields,
      ['paymentMode']: utr,
    });
  }, [utr]);

  useEffect(() => {
    setFormFields({
      ...formFields,
      ['utr']: utrId,
    });
  }, [utrId]);

  useEffect(() => {
    setFormFields({
      ...formFields,
      ['transactionAmount']: transactionAmount,
    });
  }, [transactionAmount]);

  useEffect(() => {
    setFormFields({
      ...formFields,
      ['transactionTime']: time?.text,
    });
  }, [time]);

  useEffect(() => {
    setFormFields({
      ...formFields,
      ['paymentScreenshot']: files?.[0],
    });
  }, [files]);

  useEffect(() => {
    let postObjectCache = postObject;
    postObjectCache.bankName = formFields.bankName;
    postObjectCache.utr = formFields.utr;
    postObjectCache.paymentScreenshot = formFields.paymentScreenshot;
    postObjectCache.transactionAmount = formFields.transactionAmount;
    postObjectCache.paymentMode = formFields.paymentMode;
    postObjectCache.transactionDateTime = `${dateformat(formFields.transactionDate, 'yyyy-mm-dd')}`;
    setPostObject({
      ...postObjectCache,
    });
  }, [formFields]);

  useEffect(() => {
    if (
      postObject.bankName &&
      postObject.paymentMode &&
      postObject.transactionAmount &&
      postObject.transactionDateTime &&
      postObject.utr &&
      postObject.paymentScreenshot
    ) {
      setIsDisabled(false);
    } else {
      !isDisabled && setIsDisabled(true);
    }
  }, [postObject]);

  const updateQueryCaller = data => {
    if (data.startDate) {
      setDates({
        startDate: data.startDate,
        //endDate: data.endDate
      });
      setFormFields({
        ...formFields,
        ['transactionDate']: data.startDate,
      });
    }
    setShowDate(false);
    setCalenderHandle(false);
  };

  const showDateHandler = () => {
    setShowDate(true);
    setCalenderHandle(true);
  };

  useOutsideClick(startDateRef, () => {
    setCalendarMode('');
    setShowDate(false);
  });

  useOutsideClick(listRef, () => {
    setFieldIsFocus(false);
  });

  const listFilter = item => {
    return item.toLowerCase().includes(inputValue.toLowerCase());
  };

  const inputValueHandeler = (value, name) => {
    setInputValue(value);
    setFormFields({
      ...formFields,
      [name]: value,
    });
  };

  const listClickHandler = (formName, formValue) => {
    setFormFields({
      ...formFields,
      [formName]: formValue?.innerHTML,
    });
    inputValueHandeler(formValue?.innerHTML, formName);
    setFieldIsFocus(false);
  };

  const handleSubmit = () => {
    dispatch(postRefundRaiseRequest(postObject, successCallback, errorCallback));
    sendTrackingDataToSdk?.(
      {
        event_detail: {
          event_name: 'click',
          event_type: 'user_action',
          event_value: 'Submit Request Clicked',
        },
      },
      'REFUND_RAISE_REQUEST',
    );
    return false;
  };

  const successCallback = data => {
    closeModal();
    setModalFlag(false);
    setFailureMessage('');
    location.reload();
  };

  const errorCallback = dataMessage => {
    if (dataMessage == 'Raised within TAT') {
      setFailureMessage("Can't raise within 3 hours");
    } else setFailureMessage(dataMessage);
    setUtrId('');
    setTransactionAmount('');
    setFiles([]);
    setInputValue('');
    setIsDisabled(true);
    setTime('');
    setUtr('');
  };

  const closeModalClick = () => {
    closeModal();
  };

  const handleTimeChange = e => {
    setTime(e.target.value);
  };

  const searchInputField = (formName, formValue) => {
    return (
      <S.SearchInputField ref={listRef}>
        <div className={`formInpWpr bd `}>
          <input
            id={formName}
            type="text"
            value={inputValue}
            className={`formInpFld inputFieldWrapper`}
            placeholder={'Type your Bank'}
            onChange={e => inputValueHandeler(e.target.value, formName)}
            onFocus={() => setFieldIsFocus(true)}
            //onBlur={() => setFieldIsFocus(false)}
            name={formName}
          />
          {ccdeCookie !== 'AE' && fieldIsFocus && (
            <ul
              className="formInpDropdown"
              //onMouseEnter={() => setShouldFocusOut(false)}
              //onMouseLeave={() => setShouldFocusOut(true)}
            >
              {inputValue &&
                bankName.filter(listFilter).map((itm, idx) => (
                  <li key={idx} onClick={e => listClickHandler(formName, e.target)}>
                    {itm}
                  </li>
                ))}
              {/*<li
                            className="latoBold"
                            onClick={() => {
                                //if (dropdownClickers.addingTrvllrClicker !== undefined) dropdownClickers.addingTrvllrClicker();
                                //setIsFieldFocus(false);
                            }}
                        >
                            <span>No Data Found</span>
                        </li>*/}
            </ul>
          )}
        </div>
      </S.SearchInputField>
    );
  };

  return (
    <S.FormCont>
      <form method="post">
        <S.FormBody>
          <S.FormHeading>Raise Your request</S.FormHeading>
          <S.CloseBtn onClick={closeModalClick} />
          {ccdeCookie !== 'AE' && (
            <S.FormSubHeading>
              Raise request here in case you have deposited the money but the{' '}
              <span>wallet balance is not updated after 15 minutes.</span>
            </S.FormSubHeading>
          )}
          <S.FormWrap>
            <S.FormLeft>
              {/*<S.FrmRow>
                            <S.FrmColLeft>
                                <label>Account Holder Name</label>
                                <p>As per your bank statement</p>
                            </S.FrmColLeft>
                            <S.FrmColRight>
                                <TextInput
                                    placeholder="Enter Your Name"
                                    id={1} name={'harman'}
                                    hasRupeesSymbol={false}
                                    onChange={handleTextChange}
                                    width={'300px'}
                                    calendarIcon />
                            </S.FrmColRight>
                        </S.FrmRow>*/}
              <S.FrmRow>
                <S.FrmColLeft>
                  <label>Payment Mode</label>
                  {ccdeCookie !== 'AE' && <p>Select from dropdown</p>}
                </S.FrmColLeft>
                <S.FrmColRight>
                  {ccdeCookie === 'AE' ? (
                    <TextInput
                      placeholder="Enter Payment Mode"
                      id={2}
                      name={'paymentMode'}
                      onChange={setUtr}
                      width={'300px'}
                      value={utr}
                      type="text"
                    />
                  ) : (
                    <SelectBox
                      placeholder="Select Payment Mode"
                      options={paymentModeData}
                      width={'300px'}
                      isError={false}
                      errorMsg=""
                      onChange={setUtr}
                      value={utr}
                    />
                  )}
                </S.FrmColRight>
              </S.FrmRow>
              <S.FrmRow>
                <S.FrmColLeft>
                  <label>Transaction Date</label>
                  <p>Select from dropdown</p>
                </S.FrmColLeft>
                <S.FrmColRight>
                  <S.Transaction>
                    <S.StatementTimeWrap onClick={showDateHandler}>
                      <S.StatementTimeInnerWrap>
                        <S.FromTimeWrap>
                          <S.FromTimeMainText>
                            {dateformat(walletStatementDates.startDate, 'dd/mm/yyyy')}
                          </S.FromTimeMainText>
                        </S.FromTimeWrap>
                        {showDate && calenderHandle && (
                          <S.CalendarWrapperFrom>
                            <CalendarBlock
                              ref={startDateRef}
                              isSearchWidget={true}
                              isStartMode={calendarMode === 'start'}
                              onSelection={() => setCalendarMode('start')}
                              updateQueryCaller={updateQueryCaller}
                              startDate={walletStatementDates.startDate}
                              //endDate={new Date()}
                              isEndMode={calendarMode === 'end'}
                            />
                          </S.CalendarWrapperFrom>
                        )}
                      </S.StatementTimeInnerWrap>
                    </S.StatementTimeWrap>
                    {/*<input type="time" onChange={handleTimeChange} />*/}
                  </S.Transaction>
                </S.FrmColRight>
              </S.FrmRow>
              <S.FrmRow>
                <S.FrmColLeft>
                  <label>Transaction Amount</label>
                </S.FrmColLeft>
                <S.FrmColRight>
                  <TextInput
                    hasRupeesSymbol
                    placeholder="Enter Your Amount"
                    id={1}
                    name={'INR'}
                    onChange={setTransactionAmount}
                    width={'300px'}
                    value={transactionAmount}
                    type="number"
                    ccdeCookie={ccdeCookie}
                  />
                </S.FrmColRight>
              </S.FrmRow>
              <S.FrmRow>
                <S.FrmColLeft>
                  <label>{ccdeCookie === 'AE' ? 'Reference ID' : 'UTR/URN/Reference ID'}</label>
                  <p>Prefilled from your bank statement</p>
                </S.FrmColLeft>
                <S.FrmColRight>
                  <TextInput
                    placeholder={
                      ccdeCookie === 'AE' ? 'Reference ID' : 'Enter UTR/URN/Reference ID'
                    }
                    id={1}
                    name={'dummy'}
                    hasRupeesSymbol={false}
                    onChange={setUtrId}
                    width={'300px'}
                    value={utrId}
                    type="text"
                  />
                </S.FrmColRight>
              </S.FrmRow>
              <S.FrmRow>
                <S.FrmColLeft>
                  <label>Bank Name</label>
                  {ccdeCookie !== 'AE' && <p>Select from dropdown</p>}
                </S.FrmColLeft>
                {searchInputField('bankName', formFields.bankName)}
              </S.FrmRow>
            </S.FormLeft>
            <S.FormRight>
              <Uploader setFiles={setFiles} uploadedFiles={files} />
            </S.FormRight>
          </S.FormWrap>
        </S.FormBody>
        <S.FormFooter>
          {failureMessage && <span>{failureMessage}</span>}{' '}
          <S.BtnSubmit type="button" disabled={isDisabled} onClick={handleSubmit}>
            SUBMIT your Request
          </S.BtnSubmit>
        </S.FormFooter>
      </form>
    </S.FormCont>
  );
};

export default RaiseWalletRequest;
